import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
    constructor(private languageService: LanguageService) {}

    get currentLanguage(): string {
        return this.languageService.getLanguage();
    }

    setLanguage(language: string): void {
        if (language !== this.currentLanguage) {
            this.languageService.setLanguage(language);
        }
    }
}
